import React, { createContext, useContext, useState } from "react";

const CourseContext = createContext(null);

export const CourseProvider = ({ children }) => {
  const [course, setCourse] = useState(null);

  return (
    <CourseContext.Provider value={{ course, setCourse }}>
      {children}
    </CourseContext.Provider>
  );
};

export const useCourse = () => useContext(CourseContext);
